<!-- Navbar for Special Routes (Enquiry/Prospective) -->
<nav v-if="!should_hide_entire_navbar && ($route.name === 'enquiry_landing_page' || $route.name === 'prospective_applicant' || $route.name === 'jobs_advertised')" class="navbar navbar-expand-lg bg-light sticky-top px-0 navbar-landing">
  <div class="container-fluid px-0 py-0 d-flex align-items-center flex-nowrap">
    <div class="d-flex align-items-center flex-shrink-0">
      <a class="border-0 d-flex align-items-center me-2" id="navbar_logo">
        <img :src="$clientLogo" alt="Logo" class="logo-img mt-2" width="120px">
      </a>
    </div>

    <!-- Simplified navbar for enquiry landing page -->
    <div class="d-flex align-items-center ms-auto flex-nowrap gap-2">
      <button
        v-if="has_support_email"
        type="button"
        class="nav-link text-xxs btn btn-sm p-1 btn-primary-dark rounded-small flex-shrink-0"
        data-bs-toggle="modal"
        data-bs-target="#contactUsModal"
      >
        Contact Us
      </button>

      <a
        class="nav-link text-xxs btn btn-sm p-1 btn-primary-dark rounded-small flex-shrink-0"
        href="#"
        @click="go_to_register"
      >
        Register
      </a>
      <a class="nav-link text-xxs btn btn-sm p-1 btn-primary-dark rounded-small flex-shrink-0" href="#" @click.prevent="go_to_login">Login</a>
    </div>
  </div>
</nav>

<!-- Navbar for Company Management Page (Any Role) -->
<nav v-else-if="!should_hide_entire_navbar && should_show_navbar" class="navbar proba-topbar navbar-expand-lg bg-light px-0 py-1">
  <div class="container-fluid px-0 py-0">
    <div class="d-flex align-items-center ms-3">
      <a class="border-0 d-flex align-items-center me-3" id="navbar_logo">
        <img :src="$clientLogo" alt="Logo" class="logo-img" width="80px">
      </a>
    </div>

    <!-- Navbar Items on company management -->
    <div class="d-flex align-items-center ms-auto">
      <button
      :class="{ 'd-none': user_role === 'System Admin' }"
      class="me-3 text-xs text-dark border-0 bg-transparent" href="/" 
      @click.prevent="logout"
      data-bs-toggle="tooltip"
      data-bs-placement="bottom"
      title="Log out of your account">
      <i class="bi bi-box-arrow-right fs-5"></i>
      </button>
    </div>
  </div>
</nav>

<!-- Standard Navbar for All Other Authenticated Roles -->
<nav v-else-if="!should_hide_entire_navbar" class="navbar proba-topbar navbar-expand-lg bg-light sticky-top px-0 p-2">
  <div class="container-fluid d-flex align-items-center justify-content-between">

    <!-- LEFT SECTION -->
    <div class="d-flex align-items-center gap-3">
      <a class="border-0 d-none align-items-center me-1 dwypd-navbar-logo" id="navbar_logo">
        <img :src="$clientLogo" alt="Logo" class="logo-img" width="190px">
      </a>

      <div v-if="should_show_user_chip_in_navbar && current_user_name" class="navbar-user-chip d-inline-flex align-items-center gap-2 flex-shrink-0">
        <div class="avatar-circle navbar-chip-avatar text-capitalize flex-shrink-0">
          {{ user_initials }}
        </div>
        <span class="navbar-chip-name fw-700 text-nowrap">
          {{ current_user_name }}
        </span>
      </div>

      <div href="#" class="border-0 d-flex align-items-center me-3" id="sidebar-toggle">
        <span class="d-none" @click.stop="$emit('toggle-sidebar')">
          <i class="bi bi-list fs-5 me-2"></i>
        </span>

         <i v-if="user_role === 'System Admin'"
          class="bi bi-house fs-5 text-dark fw-bold"
          @click.stop="go_to_home"
          role="button">
        </i>
        <i v-else-if="user_role === 'Entity' && user_role !== 'Lead' && showBackToJobs" 
          class="bi bi-chevron-left fs-5 text-dark fw-bold"
          @click.stop="$router.push('/view_all_user_forms')"
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          title="Go back to job posts"
          role="button">
          <span class="text-x p-1 fw-600">Back To Jobs</span>
        </i>

        <!-- Project Badge (hidden on configure_company_management) -->
        <span
          v-if="user_role === 'System Admin' && $route.name !== 'configure_company_management'"
          class="project-badge rounded-lg text-dark ms-5 d-inline-flex justify-content-between text-xs px-1 align-items-center"
        >
          <router-link
            :to="breadcrumb_root_path"
            class="project-badge-root text-decoration-none"
          >
            {{ breadcrumb_root_label }}
          </router-link>
          <span class="px-2 text-x project-badge-separator">></span>
          <span class="fw-bold project-badge-current">{{ current_breadcrumb }}</span>
        </span>
      </div>
    </div>

    <!-- CENTER: GLOBAL SEARCH -->
    <div
      v-if="user_role === 'System Admin' || user_role === 'Entity' || user_role === 'Lead' && $route.name !== 'configure_company_management'"
      class="d-none d-md-flex align-items-center w-25 w-md-75 w-lg-50 mt-2 px-2 px-lg-0 p-0"
    >
      <div class="position-relative flex-grow-1 w-100">

        <i class="bi bi-search position-absolute top-50 start-0 translate-middle-y ps-3 text-xs"></i>

        <input
          type="text"
          class="form-control form-control-sm ps-5 shadow-lg rounded-lg text-xs slender-input"
          placeholder="Global Search"
          v-model="searchQuery"
          @input="handle_search_input"
          @focus="show_global_search = true"
        >

        <GlobalSearch
          ref="global_search"
          :show="show_global_search"
          :search-query="searchQuery"
          :project-id="project_id"
          :headers="headers"
          @close="show_global_search = false"
        />
      </div>
    </div>

    <!-- RIGHT SECTION -->
    <div class="d-flex align-items-center flex-nowrap gap-3">

      <!-- System Notifications MUST ALWAYS BE MOUNTED -->
      <SystemNotifications
        ref="system_notifications"
        :show="show_notifications"
        @close="show_notifications = false"
        @mark-all-read="update_unread_count(0)"
        @view-notification="handle_notification_click"
        @update-unread-count="update_unread_count"
      />

      <!-- Generate Self-Onboarding Link (hidden on configure_company_management) -->
      <template v-if="$route.name !== 'configure_company_management'">
        <a
          v-if="company_name === 'null'"
          class="btn btn-primary-dark disabled btn-sm rounded-small text-xxs shadow text-dark d-none"
        >
          Generate Self-Onboarding link
        </a>

        <a
          v-else-if="user_role !== 'Entity' && company_name !== 'null'"
          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark d-none"
          data-bs-toggle="modal"
          data-bs-target="#create_new_user"
          @click="generate_share_link"
        >
          Generate Self-Onboarding link
        </a>
      </template>

      <!-- Notification Bell + Logout + Profile -->
      <div class="d-flex align-items-center gap-1">

        <!-- Notification Bell (hidden on configure_company_management) -->
        <template v-if="$route.name !== 'configure_company_management' && !should_show_logout_only_actions">
          <a href="#" @click.prevent="toggle_notifications" 
            class="position-relative"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            title="Notifications">
            <i class="bi bi-bell me-2 fs-5 text-dark"></i>
            <span v-if="unread_notifications_count > 0" class="notification-badge">
              {{ unread_notifications_count > 9 ? '9+' : unread_notifications_count }}
            </span>
          </a>
        </template>

        <!-- LOGOUT ALWAYS VISIBLE -->
        <a class="me-2 text-xxs border-0 rounded-small" href="/" @click.prevent="logout"
            :class="{ 'd-none': user_role === 'System Admin' }"
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            title="Log Out">
          <i class="bi bi-box-arrow-right fs-5 text-dark"></i>
        </a>

        <!-- Profile Dropdown (hidden on configure_company_management) -->
        <template v-if="$route.name !== 'configure_company_management' && !should_show_logout_only_actions">
          <button
            type="button"
            class="profile-chip-button border-0 d-inline-flex align-items-center gap-2"
              data-bs-toggle="modal"
              data-bs-target="#profile_settings_modal"
              title="Profile"
          >
            <span class="avatar-circle navbar-chip-avatar text-capitalize flex-shrink-0">
              {{ user_initials }}
            </span>
            <span
              v-if="!is_dwypd_recruitment_domain"
              class="navbar-chip-name fw-700 text-nowrap"
            >
              {{ navbar_user_label }}
            </span>
          </button>
        </template>

      </div>
    </div>
  </div>
</nav>

<AiconeLogo />

<!-- Modal -->
 <teleport to="body">
<div class="modal fade" id="create_new_user" tabindex="-1" aria-labelledby="create_user_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs d-none" id="create_user_label">Generate Self-Onboarding link</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <p class="text-muted mb-3 text-xs">
          Share the link below to let entities register under your organisation:
        </p>

        <!-- Copy link -->
        <div class="input-group mb-3 text-xxs">
          <input
            type="text"
            class="form-control text-xs"
            v-model="share_link"
            readonly
          />
          <button
            class="btn btn-primary-dark btn-sm rounded-small text-xxs fw-bold text-dark"
            @click="copy_link"
          >
            Copy
          </button>
        </div>

        <!-- Email share -->
        <label class="text-muted text-xxs mb-1">Share via Email</label>

        <div class="input-group text-xxs">
          <input
            type="email"
            class="form-control text-xs"
            placeholder="Enter email address"
            v-model="share_email"
          />
          <button
            class="btn btn-primary-dark btn-sm rounded-small text-xxs fw-bold text-dark"
            @click="share_via_email"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="contactUsModal" tabindex="-1" aria-labelledby="contact_us_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs mb-0" id="contact_us_label">Contact Us</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body p-3">
          <div class="fw-bold text-dark mb-3">Reach out directly</div>
          <div class="contact-popup-item d-flex align-items-center justify-content-between mb-3 text-break">
            <span class="text-xxs">{{ contact_email }}</span>
            <button
              type="button"
              class="contact-copy-btn ms-2"
              @click.prevent="copy_contact('email')"
              title="Copy email"
            >
              <i :class="copy_status.email ? 'bi bi-clipboard-check' : 'bi bi-clipboard'"></i>
            </button>
          </div>
          <div class="contact-popup-item d-flex align-items-center justify-content-between text-break">
            <span class="text-xxs">{{ contact_phone }}</span>
            <button
              type="button"
              class="contact-copy-btn ms-2"
              @click.prevent="copy_contact('phone')"
              title="Copy phone number"
            >
              <i :class="copy_status.phone ? 'bi bi-clipboard-check' : 'bi bi-clipboard'"></i>
            </button>
          </div>
          <div v-if="copy_status.message" class="text-success text-xxs mt-3">
            {{ copy_status.message }}
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div
    class="modal fade" id="profile_settings_modal" tabindex="-1" aria-labelledby="profile_settings_modal" aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content bg-white rounded-3 shadow-lg">

        <!-- HEADER -->
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs mb-0">Profile Information</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- BODY -->
        <div class="modal-body p-3">
          <ProfileInfo />
        </div>

      </div>
    </div>
  </div>
</teleport>

